import React from "react";

import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";

import "./RegisterBanner.scss";
import cs from "classnames";

const RegisterBanner = () => {
  const { ref: buttonRef, inView: buttonVisibility } = useInView();

  const navigate = useNavigate();

  return (
    <div className="RegisterBanner">
      <div>
        <div className="RegisterBanner__title">
          Discover Exclusive Access <br />{" "}
          <span>Experience our latest innovations..</span>
        </div>
        <div className="RegisterBanner__description">
          Join us by registering now and stay connected with our cutting-edge
          advancements.
        </div>
      </div>
      <div>
        <div
          ref={buttonRef}
          className={cs(
            "RegisterBanner__button-outside",
            buttonVisibility && "RegisterBanner__button-outside-animation",
          )}
        >
          <div
            className={cs(
              "RegisterBanner__button-middle",
              buttonVisibility && "RegisterBanner__button-middle-animation",
            )}
          >
            <div
              className="RegisterBanner__button"
              onClick={() => {
                navigate("/register-interest");
              }}
            >
              Register Interest
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterBanner;
